import { Component, OnInit, Input, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { CarburacionesService } from "../../../services/creditos/carburaciones.service";
import { EstacionariosService } from "../../../services/creditos/estacionarios.service";
import { NominasService } from "../../../services/creditos/nominas.service";
import { ComercializacionService } from "../../../services/creditos/comercializacion.service";
import { ModalFechaContratoComponent } from "./components/modal-fecha-contrato.component";

@Component({
  selector: 'header-credito',
  templateUrl: './header-credito.component.html'
})

export class HeaderCreditoComponent implements OnInit {
    public static readonly HEADER_GENERAL : string = 'General';
    public static readonly HEADER_DISTRIBUCION : string = 'Distribucion';
    public static readonly HEADER_NOMINA : string = 'Nomina';

    @ViewChild('modalFechaContrato') public modalFechaContrato: ModalFechaContratoComponent;
    @Input() public idCreditos: number = null;
    @Input() public isEditable: boolean = false;
    @Output() public updatedFechaContrato : EventEmitter<string> = new EventEmitter;
    
    //Helpers Generales
    public credito : any = { cliente: {}, prestamo: {}, sucursal: {} };
    public linkTablaAmortizacion: string = null;
    public linkSimulador: string = null;
    public tituloHeader: string = null;
    public tipoHeader: string = null;
    public fechaContrato: string = null;
    public isValidUpdateFechaContrato: boolean = false;
    
    //Creditos
    public creditoDistribucion: any = {};
    public estacionario: any = null;
    public nomina: any = null;
    public errors: any = {};

    constructor(
      private helperService: HelpersService,
      private creditosService: CreditosService,
      private carburacionesService: CarburacionesService,
      private estacionariosService: EstacionariosService,
      private nominasService: NominasService,
      private mesesService: ComercializacionService
    ){
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

      if (changes.idCreditos && this.idCreditos) {
        this.getCredito(this.idCreditos);    
        this.loadValidationFechaContrato(this.idCreditos);
      }
    }

private getCredito(idCreditos: number) {

  console.log("📌 [getCredito] Iniciando búsqueda de crédito:", idCreditos);

  this.creditosService.get(idCreditos).subscribe(
    (response) => {

      console.log("📥 [getCredito] Respuesta recibida:", response);

      const credito = response.json().content;
      this.credito = credito;

      console.log("📄 [getCredito] Crédito asignado:", credito);

      console.log("🔍 Tipo de crédito detectado (idTipos_Creditos):", credito.idTipos_Creditos);

      switch (credito.idTipos_Creditos) {

        case TiposCreditos.Carburacion:
          console.log("➡️ Entrando a flujo: **Carburación**");
          this.tipoHeader = HeaderCreditoComponent.HEADER_DISTRIBUCION;
          this.getCreditoCarburacion(idCreditos);
          break;

        case TiposCreditos.Estacionario:
          console.log("➡️ Entrando a flujo: **Estacionario**");
          this.tipoHeader = HeaderCreditoComponent.HEADER_GENERAL;
          this.getCreditoEstacionario(idCreditos);
          break;

        case TiposCreditos.Nomina:
          console.log("➡️ Entrando a flujo: **Nómina**");
          this.tipoHeader = HeaderCreditoComponent.HEADER_NOMINA;
          this.getCreditoNomina(idCreditos);
          break;

        case TiposCreditos.MesesSinIntereses:
          console.log("➡️ Entrando a flujo: **Meses Sin Intereses**");
          this.tipoHeader = HeaderCreditoComponent.HEADER_DISTRIBUCION;
          this.getCreditoMeses(idCreditos);
          break;

        default:
          console.warn("⚠️ Tipo de crédito desconocido:", credito.idTipos_Creditos);
          this.tipoHeader = HeaderCreditoComponent.HEADER_GENERAL;
          break;
      }

      console.log("🎨 Configurando labels del crédito...");
      this.setupCreditoLabels(credito);

      console.log("💰 Configurando labels del préstamo...", credito.prestamo);
      this.setupPrestamoLabels(credito.prestamo);

      console.log("✅ [getCredito] Finalizado correctamente.");

    },
    (error) => {
      console.error("❌ [getCredito] Error al obtener crédito:", error);

      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.setBackendErrors(error.json().content, this.errors);
        this.helperService.notification(
          'ERROR',
          'No se completó la acción. Por favor, intenta más tarde.',
          'error'
        );
      }
    }
  );
}


    private getCreditoCarburacion(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.carburacionesService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.creditoDistribucion = result.carburacion;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private getCreditoEstacionario(idCreditos : number){
      this.estacionariosService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.estacionario = result.estacionario;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private getCreditoNomina(idCreditos : number){
      this.nominasService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.nomina = result.nomina;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private getCreditoMeses(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.mesesService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.creditoDistribucion = result.meses;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private setupCreditoLabels(credito : any){
        let headerTitle = null;
        let linkTablaAmortizacion = null;
        let linkSimulador = null;
        linkTablaAmortizacion = '/creditos/tabla-amortizacion/' + credito.id;

        switch(credito.idTipos_Creditos){
            case TiposCreditos.Hipotecario:
                linkSimulador = '/creditos/hipotecario/simulacion/' + credito.id;
                headerTitle = 'SOLICITUD DE CRÉDITO HIPOTECARIO';
                break;
            case TiposCreditos.Automotriz:
                linkSimulador = '/creditos/automotriz/simulador/' + credito.id;
                headerTitle = 'SOLICITUD DE CRÉDITO AUTOMOTRIZ';
                break;
            case TiposCreditos.Prendario:
                linkSimulador = '/creditos/prendario/simulador/' + credito.id;
                headerTitle = 'SOLICITUD DE CRÉDITO PRENDARIO';
                break;
            case TiposCreditos.Verde:
              linkSimulador = '/creditos/verde/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CRÉDITO VERDE';
              break;
            case TiposCreditos.Personal:
              linkSimulador = '/creditos/personal/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CRÉDITO PERSONAL';
              break;
            case TiposCreditos.Nomina:
              linkSimulador = '/creditos/nomina/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CRÉDITO NÓMINA';
              break;
            case TiposCreditos.Carburacion:
              linkSimulador = '/creditos/carburacion/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CREDIGAS CARBURACIÓN';
              break;
            case TiposCreditos.Estacionario:
              linkSimulador = '/creditos/estacionario/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CREDIGAS ESTACIONARIO';
              break;
            case TiposCreditos.MesesSinIntereses:
              linkSimulador = '/creditos/meses/simulador/' + credito.id;
              headerTitle = 'SOLICITUD DE CRÉDITO COMERCIALIZACIÓN';
              break;
        }

        this.tituloHeader = headerTitle;
        this.linkTablaAmortizacion = linkTablaAmortizacion;
        this.linkSimulador = linkSimulador;

    }

    private setupPrestamoLabels(prestamo : any){
      let periodicidad_label = '';
      switch(prestamo.periodicidad){
        case 0:
            periodicidad_label = 'Semanal';
          break;
        case 1:
            periodicidad_label = 'Quincenal';
          break;
        case 2:
            periodicidad_label = 'Mensual';
          break;
      }
      this.credito.prestamo.periodicidad_label = periodicidad_label;
    }

    private loadValidationFechaContrato(idCreditos : number){
      this.creditosService.isValidUpdateFechaContrato(idCreditos).subscribe(
          (response)=>
          {
            const content = response.json().content;
            this.isValidUpdateFechaContrato = content.result;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }   
    public onUpdatedFechaContrato(nuevaFechaContrato){
      console.log('onUpdatedFechaContrato');
      this.credito.fecha_contrato = nuevaFechaContrato;
      this.updatedFechaContrato.emit(nuevaFechaContrato);
    } 
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/header-credito/header-credito.component.ts